// removed by extract-text-webpack-plugin
module.exports = {"distanceText":"distanceText__3fUKz","panel":"panel__3BLw3","loading":"loading__2DwOR","overflowPanel":"overflowPanel__JXz6n"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/Network/coms/QualityView/coms/QualityDetail/styles.scss
// module id = 2299
// module chunks = 1